module.exports = __webpack_public_path__ + "fd610a276ec8f1276dc1a6363f79e47d.svg";